import { Clock } from "lucide-react";

interface ProgressBarProps {
  percentage: number;
  estimatedTime: number;
  elapsedTime: number;
}

export default function ProgressBar({
  percentage,
  estimatedTime,
  elapsedTime,
}: ProgressBarProps) {
  const remainingTime = Math.max(0, estimatedTime - elapsedTime);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-white">التقدم</span>
        <span className="text-2xl font-bold text-cyan-400">{percentage}%</span>
      </div>

      <div className="w-full bg-slate-700 rounded-full h-3 overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-cyan-400 to-blue-400 transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>

      <div className="flex items-center justify-between pt-2">
        <div className="flex items-center gap-1 text-sm text-slate-300">
          <Clock className="w-4 h-4" />
          <span>الوقت المتبقي: {formatTime(remainingTime)}</span>
        </div>
        <span className="text-xs text-slate-400">
          {formatTime(elapsedTime)} / {formatTime(estimatedTime)}
        </span>
      </div>
    </div>
  );
}
